var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
export function getResource(_a) {
    var url = _a.url, fetchConfig = _a.fetchConfig, body = _a.body, _b = _a.setError, setError = _b === void 0 ? function () { } : _b;
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!url) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, fetchConfig), { body: JSON.stringify(body) }))];
                case 1:
                    response = _c.sent();
                    if (response.ok) {
                        return [2 /*return*/, response.json()];
                    }
                    setError({
                        description: response.statusText,
                        statusCode: response.status,
                    });
                    throw new Error();
                case 2:
                    setError({
                        description: 'Bad Request: URL undefined',
                        statusCode: 400,
                    });
                    throw new Error();
            }
        });
    });
}
export default function useFetch(_a) {
    var _this = this;
    var url = _a.url, fetchConfig = _a.fetchConfig, body = _a.body;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(undefined), response = _c[0], setResponse = _c[1];
    var _d = useState(undefined), error = _d[0], setError = _d[1];
    useDeepCompareEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof window !== 'undefined')) return [3 /*break*/, 5];
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getResource({
                                url: url,
                                fetchConfig: fetchConfig,
                                body: body,
                                setError: function (e) { return setError(e); },
                            })];
                    case 2:
                        data = _a.sent();
                        setResponse(data);
                        setError(undefined);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        setResponse(undefined);
                        return [3 /*break*/, 4];
                    case 4:
                        setIsLoading(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [url, fetchConfig, body]);
    return {
        error: error,
        isLoading: isLoading,
        response: response,
    };
}
//# sourceMappingURL=index.js.map